(function () {
    'use strict';

    class ReactRootComponentController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $element, $injector, ReactLoaderService) {
            super($scope, $injector);
            this.__objectType = 'ReactRootComponentController';
            this.ReactLoaderService = ReactLoaderService;
            this.$element = $element;

            this.$injector = $injector;
        }

        $postLink() {
            this.ReactLoaderService.getReactInstance().then(honeybookReact => {
                this.unrender  = honeybookReact.renderRoot(this.$element[0], this.$injector);
            });

        }

        $onDestroy() {
            this.unrender();
        }

    }

    Components.ReactRootComponent = {
        template: '<span></span>',
        controller: ReactRootComponentController
    };

}());

